import { render, staticRenderFns } from "./MenuProdutos.vue?vue&type=template&id=06e46c56&scoped=true"
import script from "./MenuProdutos.vue?vue&type=script&lang=js"
export * from "./MenuProdutos.vue?vue&type=script&lang=js"
import style0 from "./MenuProdutos.vue?vue&type=style&index=0&id=06e46c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e46c56",
  null
  
)

export default component.exports